/*
 * Frido Wallet controller — renders /apps/frido/wallet/balance +
 * /apps/frido/wallet/transactions. Shows balance + the latest few transactions;
 * "View all" opens a right-side drawer (cart style) with All / Credited / Debited
 * tabs over the full, paginated list (filtered client-side — the proxy
 * transactions route only accepts count/skip, not a type filter).
 *
 * Amounts are integer paise from Razorpay; displayed as ₹ via rupeesFromPaise.
 */
(function () {
  "use strict";

  var PAGE = 20;

  function creditIcon() {
    return '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10" fill="#1f9d4d"/><path d="M7 12l3.2 3.2L17 8.6" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }
  // Inlined from the merchant's Frame icon sprite (a <symbol> renders blank as an
  // <img>, and external <use href> is blocked cross-origin — so inline the path).
  function debitIcon() {
    return '<svg class="fr-w__tx-iconimg" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path fill="#307FE2" d="M9.91536 1.16602C10.3795 1.16602 10.8246 1.35039 11.1528 1.67858C11.481 2.00677 11.6654 2.45189 11.6654 2.91602V12.2493C11.6654 12.355 11.6367 12.4586 11.5825 12.5492C11.5282 12.6398 11.4503 12.714 11.3572 12.7638C11.2641 12.8136 11.1592 12.8372 11.0537 12.8321C10.9482 12.827 10.8461 12.7933 10.7583 12.7347L9.40611 11.8334L8.57778 12.6618C8.47733 12.7622 8.34369 12.8225 8.20193 12.8315C8.06016 12.8404 7.92002 12.7972 7.80778 12.7102L7.75295 12.6618L6.9987 11.9081L6.24445 12.6618C6.144 12.7622 6.01036 12.8225 5.8686 12.8315C5.72683 12.8404 5.58668 12.7972 5.47445 12.7102L5.41961 12.6618L4.5907 11.8334L3.23911 12.7347L3.22803 12.7417L3.19653 12.7592L3.1802 12.7691L3.1487 12.7825L3.11953 12.7959L3.09095 12.8047L3.05595 12.8158L3.02561 12.821L2.99236 12.8274L2.94336 12.8309L2.9282 12.8327H2.91536L2.88678 12.8309H2.86403L2.85645 12.8292H2.84711L2.8232 12.8245L2.80103 12.8216L2.79228 12.8187L2.78178 12.8175L2.76195 12.8111L2.73861 12.8053L2.72753 12.8012L2.71878 12.7988L2.70186 12.7913L2.67853 12.7825L2.66628 12.7761L2.6587 12.7732L2.64236 12.7638L2.62136 12.7533L2.6132 12.7475L2.6027 12.7417L2.58053 12.7259L2.5677 12.7178L2.56186 12.7125L2.5502 12.7043L2.52395 12.6804L2.51695 12.6758L2.50295 12.6618L2.48253 12.639L2.47086 12.6273L2.46678 12.6209L2.46036 12.6139L2.4417 12.5877L2.43003 12.5731L2.42303 12.562L2.40553 12.5305L2.39561 12.5142L2.3822 12.4827L2.36878 12.4535C2.36099 12.4329 2.35436 12.4119 2.34895 12.3905L2.34311 12.3573L2.33728 12.3263L2.33203 12.2493V2.91602C2.33203 2.45189 2.51641 2.00677 2.84459 1.67858C3.17278 1.35039 3.6179 1.16602 4.08203 1.16602H9.91536ZM8.7487 3.49935H5.2487C4.49795 3.49935 4.4717 4.58668 5.17111 4.66193L5.2487 4.66602H5.83203C6.03682 4.66602 6.238 4.71993 6.41535 4.82233C6.5927 4.92472 6.73997 5.072 6.84236 5.24935H5.2487C5.09399 5.24935 4.94562 5.31081 4.83622 5.4202C4.72682 5.5296 4.66536 5.67797 4.66536 5.83268C4.66536 5.98739 4.72682 6.13576 4.83622 6.24516C4.94562 6.35456 5.09399 6.41602 5.2487 6.41602L6.84236 6.4166C6.7399 6.59384 6.59259 6.741 6.41525 6.84329C6.2379 6.94558 6.03676 6.9994 5.83203 6.99935H5.2487C4.72953 6.99935 4.46878 7.6276 4.83628 7.9951L6.58628 9.7451C6.69567 9.85446 6.84402 9.91589 6.9987 9.91589C7.15338 9.91589 7.30172 9.85446 7.41111 9.7451L7.45953 9.69027C7.54659 9.57803 7.58971 9.43788 7.5808 9.29612C7.57189 9.15435 7.51155 9.02071 7.41111 8.92027L6.54545 8.05402L6.61136 8.03243C6.97133 7.90447 7.29447 7.6903 7.55255 7.40862C7.81063 7.12695 7.9958 6.78635 8.09186 6.4166L8.7487 6.41602C8.90341 6.41602 9.05178 6.35456 9.16118 6.24516C9.27057 6.13576 9.33203 5.98739 9.33203 5.83268C9.33203 5.67797 9.27057 5.5296 9.16118 5.4202C9.05178 5.31081 8.90341 5.24935 8.7487 5.24935H8.09186C8.04702 5.07627 7.98243 4.90892 7.89936 4.7506L7.85328 4.66602H8.7487C8.90341 4.66602 9.05178 4.60456 9.16118 4.49516C9.27057 4.38576 9.33203 4.23739 9.33203 4.08268L9.32795 4.01443C9.31123 3.87254 9.24302 3.74171 9.13625 3.64677C9.02948 3.55182 8.89158 3.49937 8.7487 3.49935Z"/></svg>';
  }

  // Boxed rupee glyph for the desktop transactions-card header (data-tx-head).
  function txHeadIcon() {
    return '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 5h12"/><path d="M6 9h12"/><path d="M6 5c5.5 0 8 1.6 8 4s-2.5 4-8 4h1.5L16 20"/></svg>';
  }
  function viewAllArrow() {
    return '<svg viewBox="0 0 18 18" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.75 9h10.5"/><path d="M9.75 4.5l4.5 4.5-4.5 4.5"/></svg>';
  }

  // creditPaise/debitPaise are authoritative; fall back to amountPaise sign.
  function classify(item) {
    var creditP = Number(item.creditPaise) || 0;
    var debitP = Number(item.debitPaise) || 0;
    if (creditP > 0) return { isDebit: false, amtPaise: creditP };
    if (debitP > 0) return { isDebit: true, amtPaise: debitP };
    var amt = Number(item.amountPaise) || 0;
    return { isDebit: amt < 0, amtPaise: Math.abs(amt) };
  }

  function init(root) {
    var F = window.FridoOrders;
    var balanceEl = root.querySelector("[data-fr-balance]");
    var txEl = root.querySelector("[data-fr-tx]");
    var drawer = root.querySelector("[data-fr-drawer]");
    var drawerList = root.querySelector("[data-fr-drawer-list]");
    var drawerBal = root.querySelector("[data-fr-drawer-bal]");
    var previewCount = parseInt(root.getAttribute("data-preview-count"), 10) || 3;
    var forceViewAll = root.getAttribute("data-force-viewall") === "true";
    var balanceBg = root.getAttribute("data-balance-bg") || "";
    var balanceBgDesktop = root.getAttribute("data-balance-bg-desktop") || "";
    var loginPath = root.getAttribute("data-login-path") || "/customer_authentication/login";
    var whatsappPhone = root.getAttribute("data-whatsapp-phone") || "";

    var balance = null;
    var loadedTx = null; // transactions fetched on the main page (seeds the drawer)

    // ── Help → WhatsApp (generic message) ───────────────────────────────
    (function setHelpLinks() {
      var url = whatsappPhone
        ? "https://api.whatsapp.com/send?phone=" + encodeURIComponent(whatsappPhone) + "&text=" + encodeURIComponent("Hi, I need support with my wallet.")
        : "#";
      root.querySelectorAll("[data-fr-help]").forEach(function (el) {
        el.setAttribute("href", url);
        el.setAttribute("target", "_blank");
        el.setAttribute("rel", "noopener");
      });
    })();

    root.querySelectorAll("[data-fr-back]").forEach(function (el) {
      el.addEventListener("click", function () {
        if (history.length > 1) history.back();
        else window.location.href = "/";
      });
    });

    function F_money(paise) { return F.escapeHtml(F.rupeesFromPaise(paise)); }

    function txRow(item) {
      var c = classify(item);
      var label = c.isDebit ? "Paid" : "Deposited";
      var sign = c.isDebit ? "−" : "+";
      var cls = c.isDebit ? "fr-w__amt--debit" : "fr-w__amt--credit";
      return (
        '<div class="fr-w__tx-row"><div class="fr-w__tx-left">' +
        '<span class="fr-w__tx-icon">' + (c.isDebit ? debitIcon() : creditIcon()) + "</span>" +
        '<div><div class="fr-w__tx-label">' + label + "</div>" +
        '<div class="fr-w__tx-date">' + F.escapeHtml(F.formatDateTime(item.createdAt)) + "</div></div>" +
        "</div>" +
        '<div class="fr-w__amt ' + cls + '">' + sign + F_money(c.amtPaise) + "</div></div>"
      );
    }

    // ── Render: balance + transactions ──────────────────────────────────
    function renderBalance(b) {
      balance = b;
      // Render the artwork as a <picture> so each variant shows at its natural
      // aspect ratio (no cropping): desktop banner ≥768px, the mobile art below.
      var mobile = balanceBg || balanceBgDesktop;
      var pic = "";
      if (mobile) {
        var src = balanceBgDesktop ? '<source media="(min-width: 768px)" srcset="' + balanceBgDesktop.replace(/"/g, "%22") + '">' : "";
        pic = '<picture class="fr-w__card-pic">' + src + '<img class="fr-w__card-bg" src="' + mobile.replace(/"/g, "%22") + '" alt=""></picture>';
      }
      balanceEl.innerHTML =
        '<div class="fr-w__card">' + pic +
        '<div class="fr-w__card-text"><p class="fr-w__card-label">Available Balance</p>' +
        '<p class="fr-w__card-amount">' + F_money(b.balancePaise) + "</p></div></div>";
    }

    // Desktop pane opts into a header row (boxed icon + title + "View all →"
    // link) via data-tx-head; the mobile page keeps the plain title + a
    // bottom-anchored "View all transactions" button.
    var useTxHead = root.hasAttribute("data-tx-head");

    function renderTransactions(data) {
      loadedTx = data;
      var items = data.items || [];
      // "View all" when there are more than the preview, or a full page came
      // back. forceViewAll (testing) shows it whenever there's ≥1 transaction.
      var hasMore = items.length && (forceViewAll ? items.length >= 1 : items.length > previewCount || data.count >= PAGE);

      if (useTxHead) {
        // Desktop header always offers "View all" whenever there's anything to
        // show — the drawer holds the All/Credited/Debited tabs + full paginated
        // history, so it's the entry point even when the preview already fits
        // every row (mirrors the mobile page's force-view-all behaviour).
        var headLink = items.length ? '<button type="button" class="fr-w__viewall-link" data-fr-viewall>View all' + viewAllArrow() + "</button>" : "";
        var head = '<div class="fr-w__tx-head"><span class="fr-w__tx-head-ic" aria-hidden="true">' + txHeadIcon() + '</span><h2 class="fr-w__tx-title">Transactions</h2>' + headLink + "</div>";
        var body = items.length
          ? items.slice(0, previewCount).map(txRow).join("")
          : '<div class="fr-w__state"><p>No transactions yet.</p></div>';
        txEl.innerHTML = '<div class="fr-w__tx-card">' + head + body + "</div>";
      } else {
        if (!items.length) {
          txEl.innerHTML = '<div class="fr-w__tx-card"><h2 class="fr-w__tx-title">Transactions</h2><div class="fr-w__state"><p>No transactions yet.</p></div></div>';
          return;
        }
        var shown = items.slice(0, previewCount).map(txRow).join("");
        var viewAll = hasMore ? '<button type="button" class="fr-w__viewall" data-fr-viewall>View all transactions</button>' : "";
        txEl.innerHTML = '<div class="fr-w__tx-card"><h2 class="fr-w__tx-title">Transactions</h2>' + shown + viewAll + "</div>";
      }

      var btn = txEl.querySelector("[data-fr-viewall]");
      if (btn) btn.addEventListener("click", openDrawer);
    }

    // ── Drawer (All Transactions) ───────────────────────────────────────
    var drawerState = { items: [], skip: 0, done: false, loading: false, tab: "all" };

    function filtered() {
      return drawerState.items.filter(function (it) {
        if (drawerState.tab === "all") return true;
        var isDebit = classify(it).isDebit;
        return drawerState.tab === "debited" ? isDebit : !isDebit;
      });
    }

    function renderDrawer() {
      var rows = filtered().map(txRow).join("");
      drawerList.innerHTML = rows || '<div class="fr-w__state"><p>No ' + (drawerState.tab === "all" ? "" : drawerState.tab + " ") + "transactions.</p></div>";
    }

    function drawerLoad() {
      if (drawerState.loading || drawerState.done) return;
      drawerState.loading = true;
      F.proxy("/wallet/transactions", { query: { count: PAGE, skip: drawerState.skip } })
        .then(function (data) {
          var items = data.items || [];
          drawerState.items = drawerState.items.concat(items);
          drawerState.skip += items.length;
          if (items.length < PAGE) drawerState.done = true;
          renderDrawer();
        })
        .catch(function (err) {
          drawerState.done = true;
          // Never leave the skeleton spinning — show an error if we have nothing.
          if (!drawerState.items.length) {
            drawerList.innerHTML = '<div class="fr-w__state"><p>' + F.escapeHtml((err && err.message) || "Couldn't load transactions.") + "</p></div>";
          }
        })
        .then(function () { drawerState.loading = false; });
    }

    function openDrawer() {
      drawerBal.textContent = balance ? "Available Balance: " + F.rupeesFromPaise(balance.balancePaise) : "";
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add("is-open"); });
      document.body.style.overflow = "hidden";
      // Seed from the transactions already loaded on the main page — instant, no
      // refetch. Only paginate further (on scroll) if a full first page came back.
      var seed = loadedTx && loadedTx.items ? loadedTx.items.slice() : [];
      drawerState = { items: seed, skip: seed.length, done: seed.length < PAGE, loading: false, tab: drawerState.tab };
      if (seed.length) {
        renderDrawer();
      } else {
        drawerList.innerHTML = '<div class="fr-skel-line"></div><div class="fr-skel-line" style="width:80%"></div>';
        drawerLoad();
      }
    }
    function closeDrawer() {
      drawer.classList.remove("is-open");
      document.body.style.overflow = "";
      setTimeout(function () { drawer.hidden = true; }, 300);
    }
    root.querySelectorAll("[data-fr-drawer-close]").forEach(function (el) { el.addEventListener("click", closeDrawer); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !drawer.hidden) closeDrawer(); });

    root.querySelectorAll("[data-fr-tab]").forEach(function (tab) {
      tab.addEventListener("click", function () {
        drawerState.tab = tab.getAttribute("data-fr-tab");
        root.querySelectorAll("[data-fr-tab]").forEach(function (t) { t.classList.toggle("is-active", t === tab); });
        renderDrawer();
      });
    });

    drawerList.addEventListener("scroll", function () {
      if (drawerList.scrollTop + drawerList.clientHeight >= drawerList.scrollHeight - 240) drawerLoad();
    });

    // ── Load ────────────────────────────────────────────────────────────
    function showSkeleton() {
      balanceEl.innerHTML = '<div class="fr-skel-card"></div>';
      txEl.innerHTML = '<div class="fr-w__tx-card"><div class="fr-skel-line" style="width:40%"></div><div class="fr-skel-line"></div><div class="fr-skel-line" style="width:90%"></div></div>';
    }

    function showError(html) {
      balanceEl.innerHTML = "";
      txEl.innerHTML = '<div class="fr-w__state">' + html + "</div>";
    }

    function load() {
      showSkeleton();
      F.proxy("/wallet/balance")
        .then(function (b) {
          renderBalance(b);
          return F.proxy("/wallet/transactions", { query: { count: PAGE, skip: 0 } });
        })
        .then(renderTransactions)
        .catch(function (err) {
          if (err && err.code === "NOT_LOGGED_IN") {
            var ret = encodeURIComponent("/pages/account");
            showError('<h2>Please log in</h2><p>Log in to view your wallet.</p><a href="' + loginPath + "?return_to=" + ret + '">Log in</a>');
            return;
          }
          if (err && err.code === "PROVIDER_NOT_CONFIGURED") {
            showError("<h2>Wallet unavailable</h2><p>The wallet isn't available right now.</p>");
            return;
          }
          showError('<h2>Couldn\'t load your wallet</h2><p>' + F.escapeHtml(err.message || "Please try again.") + '</p><button type="button" class="fr-w__retry" data-fr-retry>Retry</button>');
          var retry = txEl.querySelector("[data-fr-retry]");
          if (retry) retry.addEventListener("click", load);
        });
    }

    load();

    // Refresh balance + transactions in place after an inline voucher
    // redemption (desktop pane) — the success popup fires this instead of
    // navigating away from the account shell.
    window.addEventListener("frido:wallet-refresh", load);
  }

  function boot() { document.querySelectorAll("[data-wallet]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
